import { render, staticRenderFns } from "./DdtMail.vue?vue&type=template&id=4e8c1280"
import script from "./DdtMail.vue?vue&type=script&lang=js"
export * from "./DdtMail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports